var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: _vm.name, required: _vm.getRequire } },
    [
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: {
            disabled:
              _vm.tips === "" || _vm.tips === null || _vm.tips === undefined,
            effect: "dark",
            content: _vm.tips,
            placement: "top",
          },
        },
        [
          _vm.maxLength != 0
            ? _c("el-input", {
                class: { require: _vm.getRequire && _vm.isNull() },
                attrs: {
                  type: "text",
                  size: "small",
                  disabled: _vm.disabled,
                  minlength: _vm.minLength,
                  maxlength: _vm.maxLength,
                  "show-word-limit": "",
                },
                on: { input: _vm.input },
                model: {
                  value: _vm.val,
                  callback: function ($$v) {
                    _vm.val = $$v
                  },
                  expression: "val",
                },
              })
            : _c("el-input", {
                class: { require: _vm.getRequire && _vm.isNull() },
                attrs: {
                  type: "text",
                  size: "small",
                  disabled: _vm.disabled,
                  minlength: _vm.minLength,
                  "show-word-limit": "",
                },
                on: { input: _vm.input },
                model: {
                  value: _vm.val,
                  callback: function ($$v) {
                    _vm.val = $$v
                  },
                  expression: "val",
                },
              }),
        ],
        1
      ),
      _vm.errorSign
        ? _c(
            "el-tooltip",
            {
              staticClass: "right",
              attrs: { effect: "dark", content: _vm.message, placement: "top" },
            },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }